import BoxInfo from '@/components/boxInfo/boxInfo';
import InformationData from '@/modules/cadastralPosition/components/informationData/informationData';
import { MoveNormalized } from '@/modules/move/entities/interfaces/move';
import useMonitoringFileDownload from '@/shared/modules/monitoring/hooks/useMonitoringFileDownload/useMonitoringFileDownload';
import React, { useMemo } from 'react';
import { Button } from 'vkit/lib/components';

interface CadastralPositionInfoProps {
  loading: boolean;
  cadastralPositionId: string;
  cadastralPosition?: MoveNormalized;
}

const CadastralPositionInfo: React.FC<CadastralPositionInfoProps> = ({
  loading,
  cadastralPositionId,
  cadastralPosition,
}) => {
  const { loading: loadingDownload, downloadFile } = useMonitoringFileDownload();

  const disabledDownloadButton = useMemo(() => {
    return loading || loadingDownload || !cadastralPositionId || !cadastralPosition?.id;
  }, [cadastralPosition?.id, cadastralPositionId, loading, loadingDownload]);

  return (
    <BoxInfo
      title='Dados da posição cadastral'
      icon='info-outline'
      header={
        <Button
          loading={loading || loadingDownload}
          disabled={disabledDownloadButton}
          icon='download-outline'
          label='Baixar arquivo'
          onClick={() => downloadFile(cadastralPosition?.id, cadastralPosition?.name)}
          iconColor={disabledDownloadButton ? 'light' : 'clear'}
        />
      }>
      <InformationData data={cadastralPosition} loading={loading} />
    </BoxInfo>
  );
};

export default CadastralPositionInfo;
